import { List } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import shareIconUrl from '../../../../../../assets/image/sidebarIcons/share.png';
import { SideBarListItem } from './SideBarListItem';
import { IntercomArticleKeys } from './types';

interface ExportOptionsItemProps {
  setMenuOpen: (event: React.MouseEvent<HTMLElement>, name: string) => void;
}

export const ExportOptionsItem = (props: ExportOptionsItemProps) => {
  const { t } = useTranslation();
  const { setMenuOpen } = props;

  return (
    <List dense>
      <SideBarListItem
        disabled={false}
        iconUrl={shareIconUrl}
        onClick={(e) => setMenuOpen(e, 'export')}
        text={t('common:dashboardSideBar.export')}
        className="intercom_sidebar_export"
        key="export"
        intercomArticleKey={IntercomArticleKeys.EXPORT}
      />
    </List>
  );
};
